import { createContext } from 'react';
import { AddressDefaultsContextType } from './address-field-types';

export const AddressDefaultsContext = createContext<AddressDefaultsContextType>(
  undefined as any
);
